import { DeepPartial, RecommendationsConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_RECOMMENDATIONS: DeepPartial<RecommendationsConfig> = { gridColumns: 1 };
export const DESKTOP_RECOMMENDATIONS: DeepPartial<RecommendationsConfig> = { gridColumns: 6 };
